<template>
  <van-nav-bar>
    <template #left>
      <van-image :src="require('../assets/home/logo.png')" width="140px" height="40px" fit="contain"></van-image>
    </template>
    <!-- <template #right>
      <van-image :src="require('../assets/home/app.png')" width="46px" height="24px" fit="contain"></van-image>
    </template> -->
  </van-nav-bar>
  <van-swipe :autoplay="3000">
    <van-swipe-item v-for="item of swipeBannerList" :key="item.Id" @click="openBannerLink(item.LinkUrl)">
      <van-image :src="item.ImageUrl" width="100%" fit="contain"></van-image>
    </van-swipe-item>
  </van-swipe>
  <router-link to="/noticDetails">
    <van-notice-bar left-icon="volume-o" scrollable background="#ffffff">
      <template #default>
        <span class="marquee-item" v-for="(item, index) of noticeBarList" :key="index" style="margin-right: 375px">{{ item.MessageContent }}</span>
      </template>
    </van-notice-bar>
  </router-link>
  <div class="tabs">
    <div :class="['item', item.code, { active: activeTab == item.code }]" @click="changeTab(item)" v-for="item of opcGames" :key="item.code">
      <van-image :src="require(`../assets/logo_${item.code}.png`)" width="38px" height="38px" fit="cover"></van-image>
      <div class="name">{{ item.name }}</div>
      <div class="dateTime" v-if="item.code !== 'game_tz' && item.code !== 'game_pc28'">{{ $moment(item.DrawTS).format("MM月DD日") }}开奖</div>
      <div class="dateTime" v-else>{{ item.DrawTS }}</div>
    </div>
  </div>
  <div class="latest">
    <div class="current">
      <div class="lotter">
        <img :src="require(`../assets/logo_${activeTab}.png`)" class="logo" />
        <div class="lotteryName">{{ opcGames[activeTab].name }}</div>
      </div>
      <div class="next" v-if="activeTab !== 'game_pc28'">
        <div class="lastRoundNo">
          距离第<span>{{ latestRound.RoundNo }}</span
          >期开奖
        </div>
        <FilpClock :seconds="latestRound.LatestTimeDiff" @finish="onFinish"></FilpClock>
        <div class="lastDate" v-if="activeTab !== 'game_pc28' && activeTab !== 'game_tz'">{{ $moment(latestRound.DrawTS).format("YYYY/MM/DD dddd HH点mm分") }}</div>
        <div class="lastDate" v-else>{{ $moment(latestRound.DrawTS).format("YYYY/MM/DD HH:mm:ss") }}</div>
      </div>
      <div class="next-tzpc" v-else>
        <div>
          <div class="tip-title">开奖时间</div>
          <div class="tip-text">首期开奖时间不固定，依官方开出时间为主</div>
        </div>
        <div>
          <div class="tip-title">开奖频率</div>
          <div class="tip-text">每天402期,3分30秒一期</div>
        </div>
      </div>
    </div>
  </div>
  <div class="lastDraw">
    <div class="lastDraw-header">
      <div class="mipai-eye" @click="changemipai">
        眯牌
        <van-icon :name="openmipai == 'true' ? 'closed-eye' : 'eye-o'" size="20" />
      </div>
      <div class="more-history" v-if="activeTab == 'game_pc28' || activeTab == 'game_tz'">
        <router-link :to="{ name: 'moreHistory', params: { id: activeTab == 'game_pc28' ? 11 : 9999, name: activeTab == 'game_pc28' ? 'PC28' : '天子六合彩' } }">
          <span class="more">更多 <van-icon name="arrow" /></span>
        </router-link>
      </div>
    </div>
    <div class="lastDraw-content">
      <div class="tab-content" v-if="activeTab !== 'game_pc28'">
        <div class="table">
          <div class="table-header">
            <div class="header-roundNo">
              <span>第</span>
              <p>{{ gameHistoryList[0]?.RoundNo }}</p>
              <span>期开奖结果</span>
            </div>
            <div class="header-dateTime" v-if="activeTab !== 'game_tz'">{{ $moment(gameHistoryList[0]?.DrawTS).format("YYYY/MM/DD") }}</div>
            <div class="header-dateTime" v-else>{{ $moment(gameHistoryList[0]?.DrawTS).format("YYYY/MM/DD HH:mm:ss") }}</div>
          </div>
          <div class="table-body" :id="`game-historyList-${0}`">
            <div class="item item-liuhecai" v-for="(item, i) of gameNumList[0]" :key="i">
              <div :class="[`ball ball-${item.color} ballIndex-${i}-${openmipai}`]" @click="openmipaiPopup(item, i)">
                <div class="ball-number">{{ item.number }}</div>
              </div>
              <div v-if="openmipai == 'true' && i === 6" class="ball-class">刮一刮</div>
              <div v-if="i !== 6" class="ball-class">{{ item.zodiac }}/{{ item.fiveElements }}</div>
              <div v-if="openmipai == 'false' && i === 6" class="ball-class">{{ item.zodiac }}/{{ item.fiveElements }}</div>
            </div>
            <div class="item">
              <div class="ball">
                <div class="icon-add">+</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-content" v-else>
        <div class="table">
          <div class="table-header">
            <div class="header-roundNo">
              <span>第</span>
              <p>{{ gameHistoryList[0]?.RoundNo }}</p>
              <span>期开奖结果</span>
            </div>
            <div class="header-dateTime">{{ $moment(gameHistoryList[0]?.DrawTS).format("YYYY/MM/DD HH:mm:ss") }}</div>
          </div>
          <div class="table-body pc28-historyList" id="game-historyList-0">
            <div class="historyList">
              <div class="item" v-for="(num, i) of formatPC28Num(gameHistoryList[0]?.DrawResult)" :key="i">
                <div class="ball ball-default">
                  <div class="ball-number">{{ formatNumber2(num) }}</div>
                </div>
                <div v-if="i !== 2" class="ball">
                  <div class="ball-number icon-add">+</div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="ball">
                <div class="ball-number icon-add">=</div>
              </div>
            </div>
            <div class="item">
              <div v-if="gameHistoryList.length > 0 && gameHistoryList[0]?.DrawResult" :class="['ball', `ball-${getColorBySum(gameHistoryList[0].DrawResult)}`]">
                <div class="ball-number">
                  {{ formatNumber2(numberSum(gameHistoryList[0].DrawResult)) }}
                </div>
              </div>
            </div>
            <canvas v-if="openmipai == 'true'" id="scratch"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="yiloufenxi" v-if="activeTab == 'game_pc28'">
    <div class="content">
      <div class="item" v-show="nopresentTimes.da">
        大<span>{{ nopresentTimes.da }}</span>
        期未出
      </div>
      <div class="item" v-show="nopresentTimes.xiao">
        小
        <span>{{ nopresentTimes.xiao }}</span>
        期未出
      </div>
      <div class="item" v-show="nopresentTimes.dan">
        单
        <span>{{ nopresentTimes.dan }}</span>
        期未出
      </div>
      <div class="item" v-show="nopresentTimes.shuang">
        双
        <span>{{ nopresentTimes.shuang }}</span>
        期未出
      </div>
      <div class="item" v-show="nopresentTimes.dadan">
        大单
        <span>{{ nopresentTimes.dadan }}</span>
        期未出
      </div>
      <div class="item" v-show="nopresentTimes.dashuang">
        大双
        <span>{{ nopresentTimes.dashuang }}</span>
        期未出
      </div>
      <div class="item" v-show="nopresentTimes.xiaodan">
        小单
        <span>{{ nopresentTimes.xiaodan }}</span>
        期未出
      </div>
      <div class="item" v-show="nopresentTimes.xiaoshuang">
        小双
        <span>{{ nopresentTimes.xiaoshuang }}</span>
        期未出
      </div>
    </div>
  </div>
  <div class="tabbar">
    <div :class="['item', { active: tabIndex == 0 }]" @click="tabIndex = 0">
      <div class="history">开奖历史</div>
    </div>
    <div :class="['item', { active: tabIndex == 1 }]" @click="tabIndex = 1">和值走势图</div>
    <div v-if="activeTab == 'game_pc28'" :class="['item', { active: tabIndex == 2 }]" @click="tabIndex = 2">遗漏分析</div>
  </div>

  <van-skeleton title :row="5" :loading="loading">
    <div class="tab-content" v-if="activeTab !== 'game_pc28'">
      <van-tabs class="historyListTab" v-model="historyListActive" v-show="tabIndex == 0" title-active-color="#005EFF" color="#005EFF" background="#F4F4F4">
        <van-tab title="号码">
          <div class="table" v-for="(item, index) of gameHistoryList" :key="index" v-show="index !== 0 && gameHistoryList.length">
            <div class="table-header">
              <div class="header-roundNo">
                <span>第</span>
                <p>{{ item.RoundNo }}</p>
                <span>期开奖结果</span>
              </div>
              <div class="header-dateTime">{{ $moment(item.DrawTS).format("YYYY/MM/DD") }}</div>
            </div>
            <div class="table-body" :id="`game-historyList-${index}`">
              <div class="item" v-for="(item, i) of gameNumList[index]" :key="i">
                <div :class="[`ball ball-${item.color}`]">
                  <div class="ball-number">{{ item.number }}</div>
                </div>
                <div class="ball-class">{{ item.zodiac }}/{{ item.fiveElements }}</div>
              </div>
              <div class="item">
                <div class="ball">
                  <div class="icon-add">+</div>
                </div>
              </div>
            </div>
          </div>
          <div class="table" v-show="tabIndex == 0 && !gameHistoryList.length">
            <div class="table-header">等待开奖。。。</div>
          </div>
        </van-tab>
        <van-tab title="大小">
          <div class="table" v-for="(item, index) of gameHistoryList" :key="index" v-show="gameHistoryList.length">
            <div class="table-header">
              <div class="header-roundNo">
                <span>第</span>
                <p>{{ item.RoundNo }}</p>
                <span>期开奖结果</span>
              </div>
              <div class="header-dateTime">{{ $moment(item.DrawTS).format("YYYY/MM/DD") }}</div>
            </div>
            <div class="table-body" :id="`game-historyList-${index}`">
              <div class="item" v-for="(item, i) of gameNumList[index]" :key="i">
                <div :class="['other', `other-${item.color}`]">
                  <div class="other-number">{{ Number(item.number) > 25 ? "大" : "小" }}</div>
                </div>
              </div>
              <div class="item">
                <div class="ball">
                  <div class="icon-add">+</div>
                </div>
              </div>
            </div>
          </div>
          <div class="table" v-show="tabIndex == 0 && !gameHistoryList.length">
            <div class="table-header">等待开奖。。。</div>
          </div>
        </van-tab>
        <van-tab title="单双">
          <div class="table" v-for="(item, index) of gameHistoryList" :key="index" v-show="gameHistoryList.length">
            <div class="table-header">
              <div class="header-roundNo">
                <span>第</span>
                <p>{{ item.RoundNo }}</p>
                <span>期开奖结果</span>
              </div>
              <div class="header-dateTime">{{ $moment(item.DrawTS).format("YYYY/MM/DD") }}</div>
            </div>
            <div class="table-body" :id="`game-historyList-${index}`">
              <div class="item" v-for="(item, i) of gameNumList[index]" :key="i">
                <div :class="['other', `other-${item.color}`]">
                  <div class="other-number">{{ Number(item.number) % 2 == 0 ? "双" : "单" }}</div>
                </div>
              </div>
              <div class="item">
                <div class="ball">
                  <div class="icon-add">+</div>
                </div>
              </div>
            </div>
          </div>
          <div class="table" v-show="tabIndex == 0 && !gameHistoryList.length">
            <div class="table-header">等待开奖。。。</div>
          </div>
        </van-tab>
      </van-tabs>
      <div class="table" v-show="tabIndex == 1">
        <div class="table-list">
          <div class="list list-title">
            <div class="item item-roundNo">期号</div>
            <div class="item item-title">和值</div>
            <div class="item">大</div>
            <div class="item">小</div>
            <div class="item">单</div>
            <div class="item">双</div>
          </div>
          <div class="list" v-for="(item, index) of gameHistoryList" :key="index">
            <div class="item item-roundNo">{{ item.RoundNo }}</div>
            <div class="item item-title">{{ numberSum(item.DrawResult) }}</div>
            <div class="item item-B">
              <span v-show="numberSum(item.DrawResult) >= 175">{{ numberSum(item.DrawResult) >= 175 ? "大" : "小" }}</span>
            </div>
            <div class="item item-S">
              <span v-show="numberSum(item.DrawResult) <= 175">{{ numberSum(item.DrawResult) >= 175 ? "大" : "小" }}</span>
            </div>
            <div class="item item-E">
              <span v-show="numberSum(item.DrawResult) % 2 !== 0">{{ numberSum(item.DrawResult) % 2 == 0 ? "双" : "单" }}</span>
            </div>
            <div class="item item-O">
              <span v-show="numberSum(item.DrawResult) % 2 == 0">{{ numberSum(item.DrawResult) % 2 == 0 ? "双" : "单" }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-content" v-else>
      <div class="table" v-show="tabIndex == 0 && gameHistoryList.length">
        <van-row class="row-header">
          <van-col span="6">期号</van-col>
          <van-col span="6">时间</van-col>
          <van-col span="6">开奖号码</van-col>
          <van-col span="6">总和</van-col>
        </van-row>
        <van-row v-show="index !== 0" v-for="(item, index) of gameHistoryList" :key="index">
          <van-col class="table-col" span="6">{{ item.RoundNo }}</van-col>
          <van-col class="table-col" span="6">{{ item.DrawTS.split("T")[1] }}</van-col>
          <van-col class="table-col" span="6">
            <span v-for="(num, i) of formatPC28Num(item.DrawResult)" :key="i">{{ num }}</span>
          </van-col>
          <van-col :class="['table-col', getColorBySum(item.DrawResult)]" span="6">{{ numberSum(item.DrawResult) }}</van-col>
        </van-row>
      </div>
      <div class="table" v-show="tabIndex == 0 && !gameHistoryList.length">
        <div class="table-header">等待开奖。。。</div>
      </div>
      <div class="table" v-show="tabIndex == 1">
        <div class="table-list">
          <div class="list list-title">
            <div class="item item-roundNo">期号</div>
            <div class="item item-title">和值</div>
            <div class="item">大</div>
            <div class="item">小</div>
            <div class="item">单</div>
            <div class="item">双</div>
          </div>
          <div class="list" v-for="(item, index) of gameHistoryList" :key="index">
            <div class="item item-roundNo">{{ item.RoundNo }}</div>
            <div class="item item-title">{{ numberSum(item.DrawResult) }}</div>
            <div class="item item-B">
              <span v-show="numberSum(item.DrawResult) >= 14">{{ numberSum(item.DrawResult) >= 14 ? "大" : "小" }}</span>
            </div>
            <div class="item item-S">
              <span v-show="numberSum(item.DrawResult) <= 14">{{ numberSum(item.DrawResult) >= 14 ? "大" : "小" }}</span>
            </div>
            <div class="item item-E">
              <span v-show="numberSum(item.DrawResult) % 2 !== 0">{{ numberSum(item.DrawResult) % 2 == 0 ? "双" : "单" }}</span>
            </div>
            <div class="item item-O">
              <span v-show="numberSum(item.DrawResult) % 2 == 0">{{ numberSum(item.DrawResult) % 2 == 0 ? "双" : "单" }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="allnumbermiss-table" v-show="tabIndex == 2">
        <div class="allnumbermiss-table-list">
          <div class="list list-title">
            <div class="item">和值</div>
            <div class="item">未出</div>
          </div>
          <div class="list" v-for="(item, index) of allnumbermissTimes" :key="index">
            <div v-show="index % 2 == 0" class="item item-number">{{ index }}</div>
            <div v-show="index % 2 == 0" class="item">{{ item }}</div>
          </div>
        </div>
        <div class="allnumbermiss-table-list">
          <div class="list list-title">
            <div class="item">和值</div>
            <div class="item">未出</div>
          </div>
          <div class="list" v-for="(item, index) of allnumbermissTimes" :key="index">
            <div v-show="index % 2 !== 0" class="item item-number">{{ index }}</div>
            <div v-show="index % 2 !== 0" class="item">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
  </van-skeleton>
  <van-dialog v-model:show="showPopupMsg" class="popupMsg" :title="popupMessage.length ? popupMessage[popupMsgIndex].MessageTitle : ''" show-cancel-button @close="closeMessagePopup">
    <template #default>
      <div class="dialog-text">
        <div class="msg-dateTime">{{ popupMessage.length ? $moment(popupMessage[popupMsgIndex].AddTime).format("YYYY/MM/DD HH:mm:ss") : "" }}</div>
        <div class="msg-content" v-html="popupMessage.length ? popupMessage[popupMsgIndex].MessageContent : ''"></div>
      </div>
      <div class="dialog-switch">
        <div class="switch-text">今日不再提示</div>
        <van-switch v-model="todayShowPopMsg" @change="switchTodayShowMsg($event)" size="16px" active-color="#4880e0" inactive-color="#d5d5d5" />
      </div>
    </template>
    <template #footer>
      <div class="dialog-footer">
        <van-button square class="btn-next" type="primary" :disabled="popupMessage.length === 1" @click="nextMessage"> 下一条 </van-button>
        <van-button square class="btn-close" color="#ffba48" @click="closeMessagePopup"> 关闭 </van-button>
      </div>
    </template>
  </van-dialog>

  <van-overlay class="mipaiPopup" :show="showMiPaiPopup">
    <div class="wrapper">
      <div class="close-btn" @click="closeMiPaiPopup">
        <van-icon name="clear" size="28" />
      </div>
      <div class="title">刮一刮</div>
      <div class="text">特码已开出，请刮开特码体验开奖新乐趣</div>
      <div class="icon-img">
        <img src="../assets/home/icon-mipai.png" alt="" />
      </div>
      <div class="block">
        <div v-show="popupIsReady" class="darw-box">
          <div :class="`ball ball-${mipaiPopupDarw.color}`">
            <div class="ball-number">{{ mipaiPopupDarw.number }}</div>
          </div>
          <div>{{ mipaiPopupDarw.zodiac }} / {{ mipaiPopupDarw.fiveElements }}</div>
        </div>
        <canvas ref="scratchCanvas" width="279" height="112"></canvas>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { getScrollingMessage, listLotteryDrawResult, getAdvertiseList, getLatestRound, getLatestTime, getPopupMessage, getNopresentTimes, getAllnumbermissTimes } from "@/api";
import oldNumberData from "../number/number2025";
import newNumberData from "../number/number2026";
import FilpClock from "@/components/FlipClock.vue";
import { getCookie, setCookie } from "@/utils";

export default {
  name: "HomeView",
  components: {
    FilpClock,
  },
  data() {
    return {
      popupIsReady: false,
      showMiPaiPopup: false,
      mipaiPopupDarw: {},
      allnumbermissTimes: {},
      nopresentTimes: {},
      historyListActive: 0,
      openmipai: false,
      timer: null,
      loading: false,
      activeTab: "game_xg",
      tabIndex: 0,
      gameId: 12,
      gameHistoryList: [],
      lastGameHistoryList: [],
      noticeBarList: [],
      gameNumList: [],
      swipeBannerList: [],
      latestRound: {},
      latestTimeList: [],
      popupMessage: [],
      popupMsgIndex: 0,
      showPopupMsg: false,
      todayShowPopMsg: false,
      opcGames: {
        game_xg: {
          id: 12,
          code: "game_xg",
          name: "香港六合彩",
          DrawTS: "",
        },
        game_am: {
          id: 62,
          code: "game_am",
          name: "澳门六合彩",
          DrawTS: "",
        },
        game_tz: {
          id: 9999,
          code: "game_tz",
          name: "天子六合彩",
          DrawTS: "每天48期",
        },
        game_pc28: {
          id: 11,
          code: "game_pc28",
          name: "PC28",
          DrawTS: "每天402期",
        },
      },
    };
  },
  computed: {},
  watch: {
    // issue(value) {
    //   const item = this.history[this.active].find((item) => item.issue == value);
    //   if (item) {
    //     this.game.balls = item.balls;
    //     this.game.total = item.total;
    //     const combo = getComboResult(item.total, this.games[this.active].max);
    //     this.game.bigOrSmall = combo.bigOrSmall;
    //     this.game.oddOrEven = combo.oddOrEven;
    //   }
    // },
    // showGGL(show) {
    //   if (show) {
    //     // this.$refs.canvas.init()
    //   } else {
    //     this.params.status = -1;
    //     this.$refs.canvas.reset();
    //   }
    $route() {
      this.stopPolling(); // 路由改变时清除定时器
    },
  },
  created() {
    this.getLatestTime();
    this.initScrollMsg();
    this.loaderImages();
    this.getGameResult();
    this.getAdvertiseList();
    this.getLatestRound();
    this.getPopupMessage();
    this.openmipai = getCookie("openmipai") || "true";
  },
  beforeUnmount() {
    this.stopPolling();
  },
  // mounted() {
  //   this.waitForCanvasReady();
  // },
  methods: {
    openmipaiPopup(draw, index) {
      if (this.openmipai == "true" && index === 6) {
        this.mipaiPopupDarw = draw;
        this.showMiPaiPopup = true;

        // 保证 DOM 渲染完成后初始化
        this.$nextTick(() => {
          this.initMiPaiPopup();
        });
      }
    },

    closeMiPaiPopup() {
      this.showMiPaiPopup = false;
      this.popupIsReady = false;
    },

    initMiPaiPopup() {
      const canvas = this.$refs.scratchCanvas;
      if (!canvas) {
        console.error("未找到 canvas 元素");
        return;
      }
      const ctx = canvas.getContext("2d");
      canvas.width = 279;
      canvas.height = 112;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // 加载遮罩图片
      const maskImg = new Image();
      maskImg.src = require("../assets/home/mipai2.png") + "?t=" + Date.now(); // 防缓存
      maskImg.onload = () => {
        // 遮罩图加载后绘制
        ctx.globalCompositeOperation = "source-over"; // 默认绘图模式
        ctx.drawImage(maskImg, 0, 0, canvas.width, canvas.height);
        this.popupIsReady = true;
      };
      let isDrawing = false;
      const getPosition = (e) => {
        const rect = canvas.getBoundingClientRect();
        if (e.touches && e.touches.length > 0) {
          const touch = e.touches[0];
          return {
            x: touch.clientX - rect.left,
            y: touch.clientY - rect.top,
          };
        } else {
          return {
            x: e.offsetX,
            y: e.offsetY,
          };
        }
      };
      const draw = (e) => {
        if (!isDrawing) return;
        e.preventDefault();
        const pos = getPosition(e);
        ctx.globalCompositeOperation = "destination-out"; // 擦除模式
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, 20, 0, Math.PI * 2);
        ctx.fill();
      };
      // 覆盖绑定事件，防止多次 addEventListener
      canvas.onmousedown = () => (isDrawing = true);
      canvas.onmouseup = () => (isDrawing = false);
      canvas.onmousemove = draw;

      canvas.ontouchstart = () => (isDrawing = true);
      canvas.ontouchend = () => (isDrawing = false);
      canvas.ontouchmove = draw;
    },
    changemipai() {
      if (this.openmipai == "true") {
        this.openmipai = "false";
        setCookie("openmipai", false);
        if (this.activeTab == "game_pc28") {
          this.waitForCanvasReady();
        }
      } else {
        this.openmipai = "true";
        setCookie("openmipai", true);
      }
    },
    waitForCanvasReady() {
      const timer = setInterval(() => {
        const canvas = document.getElementById("scratch");
        const container = document.getElementById("game-historyList-0");

        if (canvas && container) {
          clearInterval(timer);
          this.initMiPai();
        }
      }, 100);
    },
    initMiPai() {
      const canvas = document.getElementById("scratch");
      const container = document.getElementById("game-historyList-0");
      const ctx = canvas.getContext("2d");

      canvas.width = container.offsetWidth;
      canvas.height = container.offsetHeight;

      // 绘制灰色遮罩层
      const maskImg = new Image();
      maskImg.src = require("../assets/home/mipai.png"); // 自定义遮罩图片路径
      maskImg.onload = () => {
        ctx.drawImage(maskImg, 0, 0, canvas.width, canvas.height);
      };

      let isDrawing = false;

      function getPosition(e) {
        if (e.touches && e.touches.length > 0) {
          const touch = e.touches[0];
          return {
            x: touch.clientX - canvas.getBoundingClientRect().left,
            y: touch.clientY - canvas.getBoundingClientRect().top,
          };
        } else {
          return {
            x: e.offsetX,
            y: e.offsetY,
          };
        }
      }

      function draw(e) {
        if (!isDrawing) return;
        e.preventDefault();
        const pos = getPosition(e);
        ctx.globalCompositeOperation = "destination-out"; // 擦除模式
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, 20, 0, Math.PI * 2);
        ctx.fill();
      }

      canvas.addEventListener("mousedown", () => (isDrawing = true));
      canvas.addEventListener("mouseup", () => {
        isDrawing = false;
      });
      canvas.addEventListener("mousemove", draw);

      canvas.addEventListener("touchstart", () => (isDrawing = true));
      canvas.addEventListener("touchend", () => {
        isDrawing = false;
      });
      canvas.addEventListener("touchmove", draw, { passive: false });
    },
    async initScrollMsg() {
      const res = await getScrollingMessage();
      if (res) {
        this.noticeBarList = res;
      }
    },
    loaderImages() {
      const imgs = [
        require("../assets/ggk_mask.png"),
        require("../assets/bg_dd28_selected.png"),
        require("../assets/bg_game_pc28_selected.png"),
        require("../assets/bg_game_ssc_selected.png"),
        require("../assets/bg_game_k3_selected.png"),
      ];
      imgs.forEach((img) => {
        new Image().src = img;
      });
    },
    async getGameResult() {
      this.loading = this.activeTab == "game_pc28" ? false : true;
      try {
        const res = await listLotteryDrawResult(this.gameId);
        if (res && !this.isEqual(res, this.lastGameHistoryList)) {
          this.gameHistoryList = res;
          this.lastGameHistoryList = res;
          const arr = res.map((item) => {
            return this.formatNum(item.DrawResult, item.RoundNo, item.DrawTS);
          });
          this.getNopresentTimes(res[0].RoundNo);
          this.getAllnumbermissTimes(res[0].RoundNo);
          this.gameNumList.push(...arr);
          this.waitForCanvasReady();
        }
      } finally {
        this.loading = false;
      }
    },
    async getNopresentTimes(lastRoundNo) {
      const data = {
        RoundNo: lastRoundNo,
      };
      const params = { data: JSON.stringify(data) };
      try {
        const res = await getNopresentTimes(params);
        if (res) {
          this.nopresentTimes = res;
        }
      } catch (error) {
        console.warn(error);
      }
    },
    async getAllnumbermissTimes(lastRoundNo) {
      const data = {
        RoundNo: lastRoundNo,
      };
      const params = { data: JSON.stringify(data) };
      try {
        const res = await getAllnumbermissTimes(params);
        if (res) {
          this.allnumbermissTimes = res;
        }
      } catch (error) {
        console.warn(error);
      }
    },
    startPolling() {
      if (this.activeTab == "game_pc28") {
        this.timer = setInterval(this.getGameResult, 15000);
      } else {
        this.stopPolling();
      }
    },
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    isEqual(arr1, arr2) {
      return JSON.stringify(arr1) === JSON.stringify(arr2);
    },
    async getAdvertiseList() {
      const res = await getAdvertiseList();
      if (res) {
        this.swipeBannerList = res;
      }
    },
    async getLatestRound() {
      const res = await getLatestRound(this.gameId);
      if (res) {
        this.latestRound = JSON.parse(res);
      }
    },
    async getLatestTime() {
      const res = await getLatestTime();
      if (res) {
        const latestTimeList = JSON.parse(res);
        latestTimeList.forEach((item) => {
          for (let key in this.opcGames) {
            if (this.opcGames[key].id === item.LotteryID && this.opcGames[key].id !== 9999 && this.opcGames[key].id !== 11) {
              this.opcGames[key].DrawTS = item.DrawTS;
            }
          }
        });
      }
    },
    async getPopupMessage() {
      const res = await getPopupMessage();
      const today = new Date().toLocaleDateString();
      if (res.length) {
        this.popupMessage = res;
        if (localStorage.getItem("noAlertToday") === today) {
          this.showPopupMsg = false;
        } else {
          this.showPopupMsg = true;
        }
      }
    },
    nextMessage() {
      const index = this.popupMsgIndex + 1;
      if (this.popupMessage[index]) {
        this.popupMsgIndex = index;
      }
    },
    closeMessagePopup() {
      this.showPopupMsg = false;
    },
    switchTodayShowMsg(event) {
      const today = new Date().toLocaleDateString();
      if (localStorage.getItem("noAlertToday") && !event) {
        localStorage.removeItem("noAlertToday");
        return;
      }
      localStorage.setItem("noAlertToday", today);
    },
    numberSum(drawResult) {
      if (drawResult) {
        return drawResult
          .split(",")
          .map(Number)
          .reduce((acc, curr) => acc + curr, 0);
      }
    },
    formatPC28Num(drawResult) {
      if (drawResult) {
        return drawResult.split(",").map(Number);
      }
    },
    formatNum(drawResult, roundNo, DrawTS) {
      if (!drawResult) return;
      const arr = drawResult.split(",").map(Number);
      const targetDate = "2025-01-29";
      const now = new Date(DrawTS).toISOString().slice(0, 10);
      const numData = now < targetDate ? oldNumberData : newNumberData;
      const newArr = arr.map((item) => {
        const result = {
          roundNo: roundNo,
          number: item.toString().padStart(2, "0"),
          zodiac: null,
          fiveElements: null,
          color: null,
        };
        // 查找生肖
        for (const [key, values] of Object.entries(numData.zodiac)) {
          if (values.includes(item)) {
            result.zodiac = key;
            break;
          }
        }
        // 查找五行
        for (const [key, values] of Object.entries(numData.fiveElements)) {
          if (values.includes(item)) {
            result.fiveElements = key;
            break;
          }
        }
        // 查找波色
        for (const [key, values] of Object.entries(numData.color)) {
          if (values.includes(item)) {
            result.color = key;
            break;
          }
        }
        return result;
      });
      return newArr;
    },

    formatNumber2(n) {
      return n < 10 ? "0" + n : String(n);
    },
    getColorBySum(draw) {
      if (!draw) return;
      const value = this.numberSum(draw);

      const redSums = ["01", "02", "07", "08", "12", "13", "18", "19", "23", "24"];
      const blueSums = ["03", "04", "09", "10", "14", "15", "20", "25", "26"];
      const greenSums = ["00", "05", "06", "11", "16", "17", "21", "22", "27"];

      const strVal = typeof value === "number" ? value.toString().padStart(2, "0") : value;

      if (redSums.includes(strVal)) return "red";
      if (blueSums.includes(strVal)) return "blue";
      if (greenSums.includes(strVal)) return "green";
      return "default";
    },
    async changeTab(item) {
      this.activeTab = item.code;
      this.gameId = item.id;
      this.gameHistoryList = [];
      this.gameNumList = [];
      this.getGameResult();
      this.startPolling();
      setTimeout(() => {
        this.getLatestRound();
      }, 1000);
    },
    onFinish() {
      setTimeout(() => {
        this.getGameResult();
      }, 2000);
      this.getLatestRound();
    },
    openBannerLink(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style lang="scss">
$color-blue: #0b43d7;
$color-red: #ee742f;
$color-red2: #e63442;

@mixin flex($justify: center, $alignItems: center, $direction: row) {
  display: flex;
  flex-direction: $direction;
  align-items: $alignItems;
  justify-content: $justify;
}

@mixin border($witdh: 1px, $color: #cadcfa) {
  border: $witdh solid $color;
}

.van-popup--center {
  max-width: 100vw !important;
}

.van-popup__close-icon--bottom-center {
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
}

.font-din {
  font-family: "DinPro";
  font-weight: bold;
}

.notice-swipe {
  height: 40px;
  line-height: 42px;
  .van-swipe-item {
    color: #434343;
  }
}

.tabs {
  @include flex(space-between);
  margin: 8px 12px;

  .item {
    position: relative;
    width: 78px;
    height: 84px;
    border-radius: 8px;
    @include flex(center, center, column);

    &.game_xg {
      background: linear-gradient(180deg, #ffb76f 0%, #943803 100%);
    }

    &.game_am {
      background: linear-gradient(180deg, #9921cd 0%, #060fb4 100%);
    }

    &.game_tz {
      background: linear-gradient(180deg, #5fdb46 0%, #035c5c 100%);
    }

    &.game_pc28 {
      background: linear-gradient(180deg, #4ce7c3 0%, #043eab 100%);
    }

    &.active {
      height: 96px;
      animation: active 0.3s;
      animation-fill-mode: forwards;
      z-index: 10;

      .next-cd {
        @include flex;
      }

      .name {
        color: #f14400;
        margin-top: 6px;
      }

      .dateTime {
        color: #f14400;
      }
    }

    &.active {
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px #00000026;
    }

    .name {
      font-size: 10px;
      font-weight: 700;
      color: #ffffff;
      margin: 6px 0px;
    }

    .dateTime {
      font-size: 9px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.latest {
  @include flex(space-between, flex-start, column);
  margin: 8px 12px;
  padding: 10px 10px 10px;
  @include border;
  border-radius: 4px;
  background: #fff;
  box-sizing: content-box;

  .current {
    @include flex(flex-start, center, row);
    width: 100%;

    .lotter {
      @include flex(center, center, column);
      width: 60px;

      .lotteryName {
        font-size: 10px;
        font-weight: 400;
        color: #000000;
        margin-top: 6px;
      }

      .logo {
        width: 58px;
        height: 58px;
      }
    }
  }

  .next {
    @include flex(flex-end, center, column);
    flex: 1;

    .lastRoundNo {
      margin-bottom: 4px;
      span {
        color: #e63442;
      }
    }

    .lastDate {
      font-size: 10px;
      font-weight: 500;
      color: #f14400;
      margin-top: 12px;
    }
  }

  .next-tzpc {
    display: flex;
    flex-direction: column;
    flex: 1;
    border-left: 2px solid #ebebeb;
    margin-left: 20px;
    padding-left: 20px;
    .tip-title {
      font-size: 10px;
      font-weight: 600;
      color: #000;
    }
    .tip-text {
      font-size: 10px;
      font-weight: 600;
      color: #727272;
    }
  }

  .loading {
    width: 100%;
    @include flex;
    font-size: 14px;
    color: #e63442;

    img {
      width: 25px;
      height: 25px;
    }
  }
}

.lastDraw {
  padding: 0 12px;
  .lastDraw-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px;
    background-color: #4880e0;
    color: #ffffff;
    font-size: 14px;
    .mipai-eye {
      display: flex;
      align-items: center;
      i {
        margin-left: 4px;
      }
    }

    .more-history {
      .more {
        background-color: #2d65c6;
        padding: 2px 6px;
        font-size: 12px;
        color: #ffffff;
        border-radius: 10px;
      }
    }
  }
}

.yiloufenxi {
  padding: 0 12px;
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #ffffff;
    border-radius: 5px;
    padding: 10px 0;
    .item {
      min-width: 100px;
      text-align: center;
      background-color: #696969;
      color: #fff;
      border-radius: 5px;
      margin: 5px;
      span {
        font-size: 12px;
        font-weight: 500;
        color: #44ff00;
      }
    }
  }
}

.tabbar {
  @include flex;
  margin: 8px 12px;
  position: relative;

  .item {
    @include flex;
    position: relative;
    flex: 1;
    padding: 5px 10px;
    background: #fff;
    color: #000;
    font-size: 14px;
    font-weight: 600;

    .history {
      flex: 1;
      text-align: center;
    }

    &.active {
      background: #4880e0;
      color: #ffffff;
      font-weight: bold;
    }

    &.active::before {
      content: "";
      position: absolute;
      bottom: -6px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-top: 6px solid #4880e0;
      border-right: 6px solid transparent;
      border-left: 6px solid transparent;
    }
  }
}
.lastDraw-content {
  .tab-content {
    padding-bottom: 0 !important;
    margin: 0 !important;
    .table {
      .table-body {
        height: 60px;
      }
    }
  }
}

.tab-content {
  padding-bottom: 50px;
  margin: 8px 12px;
  @include flex(center, center, column);

  .historyListTab {
    width: 100%;
  }

  .table {
    width: 100%;
    @include border(1px, #d7d7d7);
    border-radius: 4px;
    background-color: #fff;
    margin: 4px 0px;
    border: 1px solid #eeeeee;
    position: relative;

    .table-list {
      display: flex;
      flex-direction: column;
      .list {
        display: flex;
        &-title {
          .item {
            background-color: #e2e2e2;
            font-size: 12px;
            font-weight: 600;
            color: #000000;
          }
        }
        .item {
          display: flex;
          flex: 1;
          align-items: center;
          justify-content: center;
          border: 0.5px solid #eeeeee;
          height: 25px;
          span {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          &-roundNo {
            flex: 2;
          }
          &-B {
            span {
              background: #ffcf5f;
            }
          }
          &-S {
            span {
              background: #ffa450;
            }
          }
          &-E {
            span {
              background: #50adff;
            }
          }
          &-O {
            span {
              background: #ade8ff;
            }
          }
        }
      }
    }
  }

  .allnumbermiss-table {
    display: flex;
    width: 100%;
    border-radius: 4px;
    background-color: #fff;
    margin: 4px 0px;
    border: 1px solid #eeeeee;
    position: relative;

    .allnumbermiss-table-list {
      display: flex;
      flex-direction: column;
      flex: 1;
      .list {
        display: flex;
        &-title {
          .item {
            background-color: #e2e2e2;
            font-size: 12px;
            font-weight: 600;
            color: #000000;
          }
        }
        .item {
          display: flex;
          flex: 1;
          align-items: center;
          justify-content: center;
          border: 0.5px solid #eeeeee;
          height: 25px;
          &-number {
            background-color: #f4f4f4;
          }
        }
      }
    }
  }

  .table-header {
    @include flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eeeeee;
    .header-roundNo {
      display: flex;
      align-items: flex-end;
      p {
        margin: 0;
        padding: 0;
        color: #f14400;
      }
    }
    .header-dateTime {
      font-size: 10px;
      font-weight: 500;
      color: #f14400;
    }
  }

  .pc28-historyList {
    min-height: 60px;
    align-items: center;
    justify-content: center !important;
    .historyList {
      display: flex;
    }
    .item {
      display: flex;
      .ball {
        .icon-add {
          left: 11px !important;
        }
      }
    }
  }

  canvas {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999;
  }

  .table-body {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    position: relative;
    .item {
      .ball {
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        width: 30px;
        height: 30px;
        margin-bottom: 8px;

        &-red {
          background-image: url("../assets/home/redBall.png");
        }
        &-blue {
          background-image: url("../assets/home/blueBall.png");
        }
        &-green {
          background-image: url("../assets/home/greenBall.png");
        }
        &-default {
          background-image: url("../assets/home/defaultBall.png");
        }
        .ball-number {
          position: absolute;
          top: 4px;
          left: 6px;
          font-size: 14px;
          font-weight: 600;
        }
      }
      .ballIndex-6-true {
        background-image: url("../assets/home/guayigua.png") !important;
        .ball-number {
          display: none !important;
        }
      }

      .ball-class {
        font-size: 12px;
        font-weight: 400;
        color: #727272;
        letter-spacing: 2px;
      }

      .icon-add {
        text-align: center;
        align-content: center;
        font-size: 18px;
        font-weight: 600;
      }

      .other {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        &-red {
          background-color: #e53d3e;
        }
        &-blue {
          background-color: #1363e3;
        }
        &-green {
          background-color: #4aa031;
        }
        .other-number {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
    .item-liuhecai {
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 42px;
    }
    .item:nth-child(7) {
      order: 8;
    }
    .item:nth-child(8) {
      order: 7;
    }
  }

  .row-header {
    background-color: #e2e2e2;
    font-size: 12px;
    font-weight: 600;
    color: #000000;
    div {
      text-align: center;
      padding: 4px;
      border: 0.5px solid #eeeeee;
    }
  }

  .table-col {
    text-align: center;
    padding: 4px;
    border: 0.5px solid #eeeeee;
    font-size: 12px;
    font-weight: 500;
    color: #777777;
    span {
      margin: 0px 8px;
    }
  }

  .green {
    color: #4aa031;
  }
  .red {
    color: #e53d3e;
  }
  .blue {
    color: #1363e3;
  }
}

.marquee-item {
  font-size: 10px;
  color: #434343;
}

.popupMsg {
  .dialog-text {
    .msg-dateTime {
      font-size: 11px;
      font-weight: 500;
      text-align: center;
      color: #9e9e9e;
      margin-top: 6px;
    }
    .msg-content {
      text-align: center;
      padding: 0px 8px 8px 8px;
    }
  }
  .dialog-switch {
    display: flex;
    justify-content: right;
    align-items: center;
    padding: 0px 8px 8px 8px;
    .switch-text {
      font-size: 12px;
      font-weight: 400;
      color: #3f66ce;
      margin-right: 8px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      flex: 1;
      font-weight: 600;
    }
    .btn-close {
      color: #934f00 !important;
    }
  }
}

.mipaiPopup {
  z-index: 99 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    align-items: center;
    justify-content: center;
    height: 310px;
    width: 300px;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px #00000080;
    border-radius: 10px;
    position: relative;
    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #000000;
    }
    .text {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
    .icon-img {
      img {
        width: 28px;
        height: 41px;
      }
    }
  }

  .block {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 279px;
    height: 112px;
    background-image: url("../assets/home/mipai3.png");
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    .ball {
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      width: 36px;
      height: 36px;
      margin-bottom: 10px;

      &-red {
        background-image: url("../assets/home/redBall.png");
      }
      &-blue {
        background-image: url("../assets/home/blueBall.png");
      }
      &-green {
        background-image: url("../assets/home/greenBall.png");
      }
      &-default {
        background-image: url("../assets/home/defaultBall.png");
      }
      .ball-number {
        position: absolute;
        top: 4px;
        left: 6px;
        font-size: 18px;
        font-weight: 600;
      }
    }
    canvas {
      position: absolute;
    }
  }
}
</style>
